import React, { useMemo } from 'react';
import {
  Home as HomeIcon,
  Science as ScienceIcon,
  Person as PersonIcon,
  History as HistoryIcon,
  Dashboard as DashboardIcon,
  Scanner as ScannerIcon,
  Biotech as DepartmentIcon,
  AssignmentTurnedIn as RequestLabIcon,
  Inbox as InboxIcon,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import MyPatients from './MyPatients';
import LabHistory from './LabHistory';
import FinalHome from './FinalHome';
import SetupScan from './SetupScan';
import RequestedScan from './RequestedScan';
import ScanHome from './ScanHome';
import ScanHistory from './ScanHistory';
import RequestLab from './RequestLab';
import RequestScan from './RequestScan';
import AnalyzerInbox from './AnalyzerInbox';

export default function Laboratory() {
  // useMemo so the menu config keeps a stable reference between renders
  const menuItems = useMemo(() => [
    {
      key: 'Dashboard',
      label: 'Dashboard',
      icon: <DashboardIcon />,
      render: ({ navigate }) => (
        <FinalHome
          onEditRequest={(data) => {
            localStorage.setItem('labEditData', JSON.stringify(data));
            navigate('My Patients');
          }}
        />
      ),
    },
    { key: 'Set Up Lab',  label: 'Set Up Lab',  icon: <HomeIcon />,    component: Home },
    { key: 'Request Lab', label: 'Request Lab', icon: <RequestLabIcon />, component: RequestLab },
    { key: 'My Patients', label: 'My Patients', icon: <PersonIcon />,  component: MyPatients },
    { key: 'Analyzer Inbox', label: 'Analyzer Inbox', icon: <InboxIcon />, component: AnalyzerInbox },
    {
      key: 'Lab History',
      label: 'Lab History',
      icon: <HistoryIcon />,
      render: ({ navigate }) => (
        <LabHistory
          onEditResults={(data) => {
            localStorage.setItem('labEditData', JSON.stringify(data));
            navigate('My Patients');
          }}
        />
      ),
    },
    { key: 'Setup Scan',     label: 'Setup Scan',     icon: <ScannerIcon />, component: SetupScan },
    { key: 'Request Scan',   label: 'Request Scan',   icon: <RequestLabIcon />, component: RequestScan },
    { key: 'Requested Scan', label: 'Requested Scan', icon: <ScannerIcon />, component: RequestedScan },
    {
      key: 'Scan Dashboard',
      label: 'Scan Dashboard',
      icon: <DashboardIcon />,
      render: ({ navigate }) => (
        <ScanHome
          onEditScan={(data) => {
            localStorage.setItem('scanEditData', JSON.stringify(data));
            navigate('Requested Scan');
          }}
        />
      ),
    },
    // Key must match the department_components row (migration 048).
    { key: 'Scan History', label: 'Scan History', icon: <HistoryIcon />, component: ScanHistory },
  ], []);

  return (
    <DepartmentLayout
      departmentId={17}
      departmentName="Investigations"
      departmentIcon={<DepartmentIcon />}
      menuItems={menuItems}
    />
  );
}
